var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebbkarta = function SvgWebbkarta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00263E",
    fillRule: "nonzero",
    d: "m16.953 7.031-6.25 2.344c-.625.234-1.172.703-1.406 1.406l-2.344 6.25c-.234.625.39 1.25 1.016 1.016l6.25-2.344c.625-.234 1.172-.703 1.406-1.406l2.344-6.25c.234-.625-.39-1.25-1.016-1.016m-3.36 6.563c-.624.625-1.562.625-2.187 0s-.625-1.563 0-2.188 1.563-.625 2.188 0 .625 1.563 0 2.188M12.5 0C5.625 0 0 5.625 0 12.5S5.625 25 12.5 25 25 19.375 25 12.5 19.375 0 12.5 0m0 21.875c-5.156 0-9.375-4.219-9.375-9.375S7.344 3.125 12.5 3.125s9.375 4.219 9.375 9.375-4.219 9.375-9.375 9.375"
  })));
};
export default SvgWebbkarta;